import GreenMessage from './GreenMessage'
import OrangeMessage from './OrangeMessage'
import BlueMessage from './BlueMessage'

export const TEMPLATE_COMPONENTS = {
  green_message: GreenMessage,
  orange_message: OrangeMessage,
  blue_message: BlueMessage,
}

export function getTemplateComponent(templateName) {
  return TEMPLATE_COMPONENTS[templateName] || null
}
